import React from 'react';
import { getStaticViewPixel } from '@sparefoot/react-core/utils/tracking';
import { Page, Section, Container, Group } from 'components/core/Page';
import { H1, H3, Paragraph } from 'components/core/Typography';
import Button from '@sparefoot/react-core/Button';
import './ContactPageV2.scss';
import ContactPageSelector from 'store/selectors/contactpage';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Mail from '../../components/svg/Mail';
import { H5 } from '../../components/core/Typography/Typography';
import Link from '../../components/core/Link/Link';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import {
	withPageViewTracking,
	withClickTracking,
} from 'components/core/library/tracking-utils';

export const enhance = compose(
	connect(ContactPageSelector),
	withPageViewTracking(PAGE_TYPES.CONTACT),
	withClickTracking,
);

export function ContactPageV2({ canonical }) {
	return (
		<Page
			className="contact-us-page"
			trackingPixel={getStaticViewPixel()}
			pageType={PAGE_TYPES.CONTACT}
			title="Contact Us | SelfStorage.com"
			canonical={canonical}
		>
			<Section>
				<Container className="text-container">
					<Group>
						<H1 size="large">Contact SelfStorage.com</H1>

						<Paragraph className="contact-text">
							We're real people, and we like working to meet your
							needs. Whether you're searching for the best deal on
							self-storage or trying to update an existing
							reservation,
							<Link
								href="/"
								target="_blank"
							>
								{' '}
								SelfStorage.com{' '}
							</Link>{' '}
							is here for you. Reach out and contact us via phone,
							email or the contact form below. You can even go the
							old-fashioned way -- snail mail us in Austin, TX.
						</Paragraph>
					</Group>

					<Group>
						<H3 size="medium">Mailing Address:</H3>

						<Paragraph weight="bold">SelfStorage.com</Paragraph>

						<Paragraph className="address-text">
							10900 Research Blvd 160C PMB 3099
						</Paragraph>

						<Paragraph className="address-text">
							Austin, TX 78759
						</Paragraph>
					</Group>

					<Group>
						<H3 size="medium">Telephone:</H3>
						<H5 weight="bold">(512) 705-6208</H5>
					</Group>
					<Group>
						<H3 size="medium">Email Us:</H3>
						<Paragraph weight="bold">
							customerservice@selfstorage.com
						</Paragraph>
						<Button className="send-email-button">
							<Mail />
							<a
								href="mailto:customerservice@selfstorage.com?subject=SelfStorage.com%3A%20New%20Contact%20from%20Customer"
								target="_blank"
								rel="noopener noreferrer"
								className="send-email-anchor"
							>
								Send Us An Email
							</a>
						</Button>
					</Group>
				</Container>
			</Section>
		</Page>
	);
}

ContactPageV2.propTypes = {
	canonical: PropTypes.string.isRequired,
};

export default enhance(ContactPageV2);
